// These are the rules by which the form input fields will be checked against.

import { COOKIE_TYPES } from "../../config/constants/Constants";
import { formHasErrors, formHasValue, setFormValues } from "./objectValidation";

/**
 * Criteria:
 * 1) Required
 */
const typeValidation = (prevConfig, row, value) => {
    // 1)
    if (!COOKIE_TYPES.includes(value)) {
        return setFormValues(row, "type", true, "Required");
    }

    return setFormValues(row, "type", false, "");
};

/**
 * Criteria:
 * 1) Required
 * 2) Valid Netscape format
 * 3) Contains at least 2 lines
 */
const textValidation = (prevConfig, row, value) => {
    // 1)
    if (value.trim() === "") {
        return setFormValues(row, "text", true, "Required");
    }

    // 2)
    if (!value.includes("Netscape") || !value.includes("#")) {
        return setFormValues(row, "text", true, "Netscape format required");
    }

    // 3)
    const lines = value.split("\n");
    if (lines.length < 2) {
        return setFormValues(row, "text", true, "Invalid format");
    }

    return setFormValues(row, "text", false, "");
};

// The main constant, directing to the specific validation function.
export const COOKIE_VALIDATION = {
    type: {
        check: typeValidation
    },
    text: {
        check: textValidation
    }
};

export const IS_COOKIE_VALID = (obj) => {
    return !formHasErrors(obj) && formHasValue(obj, "type");
};
